import React from "react";
import { Button, Typography } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import { withStyles,makeStyles } from "@material-ui/core/styles";
import DialogContent from "@material-ui/core/DialogContent";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import Grid from "@material-ui/core/Grid";

const useStyles = makeStyles(() => ({
  Button: {
    width: "120px",
    marginRight: "20px",
    "&:hover": {
      background: "#52A1C2",
    },
  }
}));

export const SuccessDialog = (props) => {
  const classes = useStyles();
  const { isSuccess, message, handleSuccessDialog } = props;
  return (
    <Dialog
        open={isSuccess}
        onClose={handleSuccessDialog}
        maxWidth={"md"}
        PaperProps={{ style: { width: "30em", height: "20em" } }}
      >
        <DialogContent style={{ padding: "30px" }}>
          <Grid
            item
            container
            direction="column"
            justifyContent="center"
            alignItems="center"
          >
            <Grid item>
              <CheckCircleOutlineIcon
                style={{ width: "3em", height: "3em", color: "#52A1C2" }}
              />
            </Grid>
            <Grid item style={{ marginTop: "20px", marginBottom: "20px" }}>
               {message}
            </Grid>
            <Grid item>
              <Button
                onClick={() => handleSuccessDialog(false)}
                className={classes.Button}
                variant="outlined"
              >
                <Typography>OK</Typography>
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
  )
};
